import { Telemetry,ValidTelemetryEvent } from '../../commonInfra/services/Telemetry';
import { TelemetryEvents } from '../../commonInfra/telemetryEvents/TelemetryEvents';
import { UploadWorkbookErrorEvent } from '../components/UploadWorkbookDialog';
import { getFileExtension } from './UploadContentDialogHelper';

export interface UploadWorkbookEntryPointEvent extends ValidTelemetryEvent {
  type: TelemetryEvents.UploadWorkbookEntryPoint;
  origin: 'welcome-banner' | 'new-menu';
}

export interface UploadWorkbookDialogDetailEvent extends ValidTelemetryEvent {
  type: TelemetryEvents.UploadWorkbookDialogDetails;
  file_selection_type: 'DragDrop' | 'SelectButton';
  file_extension: string;
  file_size_in_kb: number;
  error_event: UploadWorkbookErrorEvent;
}

export interface UploadWorkbookActionDetailEvent extends ValidTelemetryEvent {
  type: TelemetryEvents.UploadWorkbookActionDetails;
  upload_duration_in_ms: number;
  file_size_in_kb: number;
  success: boolean;
  error_message: string;
}


export function sendUploadWorkbookEntryPointTelemetry(origin: 'welcome-banner' | 'new-menu') {
  Telemetry.sendEvent<UploadWorkbookEntryPointEvent>({
    type: TelemetryEvents.UploadWorkbookEntryPoint,
    origin: origin
  });

}

export function sendUploadWorkbookDialogTelemetry(source: 'DragDrop' | 'SelectButton', file: File, errorEvent: UploadWorkbookErrorEvent) {
  Telemetry.sendEvent<UploadWorkbookDialogDetailEvent>({
    type: TelemetryEvents.UploadWorkbookDialogDetails,
    file_selection_type: source,
    file_extension: getFileExtension(file.name),
    file_size_in_kb: file.size / 1024,
    error_event: errorEvent
  });
}

export function sendUploadWorkbookActionTelemetry(uploadDurationInMs: number, fileSize: number, isPublishSuccessful: boolean, errorMsg: string) {
  Telemetry.sendEvent<UploadWorkbookActionDetailEvent>({
    type: TelemetryEvents.UploadWorkbookActionDetails,
    upload_duration_in_ms: uploadDurationInMs,
    file_size_in_kb: fileSize / 1024,
    success: isPublishSuccessful,
    error_message: errorMsg
  });
}



